export default {
  path: '/ai',
  component: {
    render: h => h('router-view'),
  },
  children: [
    {
      path: '/ai/ai-chat',
      component: () => import('@/views/ai/ai-chat'),
    },
    {
      path: '/ai/financial-report',
      component: () => import('@/views/ai/financial-report'),
    },
    {
      path: '/ai/country-risk-report',
      component: () => import('@/views/ai/country-risk-report'),
    },
    {
      path: '/ai/country-risk-report/:id',
      component: () => import('@/views/ai/country-risk-report-view'),
    },
  ],
}
